@if (state !== 'hidden') {
    <aside class="feedback" role="status" [attr.aria-label]="'session.feedback.question' | translate">
        @if (state === 'asking') {
            <p class="feedback__question">{{ 'session.feedback.question' | translate }}</p>
            <div class="feedback__actions">
                <button
                    type="button"
                    class="feedback__thumb"
                    (click)="answer(true)"
                    [attr.aria-label]="'session.feedback.like' | translate"
                    [title]="'session.feedback.like' | translate">
                    <i-feather name="thumbs-up" class="feedback__icon"></i-feather>
                </button>
                <button
                    type="button"
                    class="feedback__thumb"
                    (click)="answer(false)"
                    [attr.aria-label]="'session.feedback.dislike' | translate"
                    [title]="'session.feedback.dislike' | translate">
                    <i-feather name="thumbs-down" class="feedback__icon"></i-feather>
                </button>
            </div>
            <button
                type="button"
                class="feedback__close"
                (click)="close()"
                [attr.aria-label]="'session.feedback.close' | translate"
                [title]="'session.feedback.close' | translate">
                <i-feather name="x" class="feedback__close-icon"></i-feather>
            </button>
        } @else {
            <p class="feedback__question">{{ 'session.feedback.thanks' | translate }}</p>
        }
    </aside>
}
